<div class="card" style="min-width:250px; max-width: 350px; padding: 0;">
  <div [routerLink]="[onlyProg?'/proposal':'/process', process._id, process.task.key, companyId]"
    style="cursor: pointer; margin: 0; padding: auto;">
    <div class="card-header"
      [ngClass]="{'programmation': step==='PROGRAMMATION', 'evaluation': step==='EVALUATION', 'execution': step==='EXECUTION'}">

      <p class="ms-3 me-2 company_title prepare-truncate"
        style="-webkit-box-orient: vertical; -moz-box-orient:vertical; margin-bottom: 0; padding-top:5px;"
        ngbTooltip="{{company_name}}">{{company_name}}</p>
      <p class="ms-3 tax_id prepare-truncate" style="-webkit-box-orient: vertical; -moz-box-orient:vertical;">{{tax_id}}
      </p>
      <p class="ms-3 tax_id" style="-webkit-box-orient: vertical; -moz-box-orient:vertical;">{{uniqueId}}</p>

    </div>
      <div class="card-body">
    <div style="width: 100%;">
      <h5 class="card-title text-muted mt-2 ms-3 me-3 mb-1" style="text-align: left;font-size: 14px;">{{step}}</h5>
    </div>

    <div class="mt-2 ms-3 me-3 mb-1">
      <h6 class="me-2" style="font-size: 14px;"><span class="text-muted">Latest task: </span>{{task}}</h6>
      <h6 class="me-2" style="font-size: 14px;"><span class="text-muted">Latest action by: </span>{{lastActionBy}}</h6>
      <h6 class="me-2" style="font-size: 14px;"><span class="text-muted">Status: </span>{{status}}</h6>
      <p class="prepare-truncate comment" [ngClass]="{'text-muted': !lastComment?.text}"
        style="-webkit-box-orient: vertical; -moz-box-orient:vertical; height: 5rem;">
        {{lastComment?.text?(lastComment?.text.length>70?lastComment?.text.substring(0,70)+'...':lastComment?.text):'...'}}
        <span
          style="position: absolute; right: 0; bottom:0; color: var(--success)"><small>{{lastComment?.user?.length>25?lastComment?.user.substring(0,25)+'...':lastComment?.user
            }} {{lastComment?.createDate | date: 'dd/MM/yyyy'}} </small></span>
      </p>

    </div>



    <div class="container">
      <div class="row">
        <div class="col-sm">
          <a [routerLink]="[onlyProg?'/proposal':'/process', process._id, process.task.key, companyId]"
          class="btn btn-outline-primary mb-2 action-button-style">
          <span>{{'CONTROL-MODULE.OPEN' | translate}}</span>
          <lucide-icon name="chevron-right" size="16"></lucide-icon>
        </a>
        </div>
        <div class="col-sm-auto">
          <a [routerLink]="['/timeline', process._id]" style="float: left;"
          class="btn btn-outline-primary ms-1 me-1 mb-2 action-button-style">
          <span>{{'CONTROL-MODULE.TIMELINE' | translate}}</span>
          <lucide-icon name="chevron-right" size="16"></lucide-icon>
        </a>
        </div>
      
      </div>
    </div>
      </div>


    <!-- <div class="ms-3 mb-2 mt-2" style="position: absolute; bottom: 40px; height: 40px;">
      <div class="d-flex flex-row">
        <div class="p-0">
          <a [routerLink]="[onlyProg?'/proposal':'/process', process._id, process.task.key, companyId]"
            class="btn btn-outline-primary ms-2 me-2 mb-2 action-button-style">
            <span>{{'CONTROL-MODULE.OPEN' | translate}}</span>
            <lucide-icon name="chevron-right" size="32"></lucide-icon>
          </a>
        </div>
        <div class="p-0"> <a [routerLink]="['/timeline', process._id]"
            class="btn btn-outline-primary ms-2 me-2 mb-2 action-button-style">
            <span>{{'CONTROL-MODULE.TIMELINE' | translate}}</span>
            <lucide-icon name="chevron-right" size="32"></lucide-icon>
          </a></div>

      </div>
    </div> -->

  </div>
</div>
